import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import { Subscription, firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class WorkflowUtilitiesService {
	private userEventSubscription!: Subscription;

	LOCALIZATION: any;

	enabled: boolean = true;

	constructor(
		private configService: ConfigService,
		private userService: UserService,
		private http: HttpClient
	) {
		this.enabled = this.configService.getConfig().dx && this.configService.getConfig().dx.enabled;

		this.userEventSubscription = this.userService.broadcastEvent.subscribe((event: string) => {
			if (event === 'localizationLoaded') {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			}
		});
	}

	async getEngineReadyState(): Promise<any> {
		let url = this.configService.getConfig().dx.baseWorkflowURL;
		url += `/services/engine/capabilities`;

		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}

	isEmptyString(str: string) {
		return str == null || ((str.trim()) == "");
	}

	// TODO move this to config.js
	getDomainCustomization(type?: string) {
		if (!type) return;
		let inclusions = [
			{ type: 'editor', access: 'DEFAULT', title: { hide: false }, subtitle: { hide: false }, approveButton: [{ isDefault: true, label: this.LOCALIZATION?.approve, tooltip: this.LOCALIZATION?.approveDocument }] },
			{ type: 'editor', access: 'OCSC', title: { hide: true }, subtitle: { hide: false, fromMetadata: ["publisher", "alternative", "resourcename", "title"] }, approveButton: [{ taskName: "First Review", label: "Submit for Approval", tooltip: "Submit for approval" }, { isDefault: true, label: this.LOCALIZATION?.approve, tooltip: this.LOCALIZATION?.approveDocument }] },
			{ type: 'annotationEditor', access: 'DEFAULT', annotationEditor: { template: "editor_tpl_minimal" } },
			{ type: 'annotationEditor', access: 'OCSC', annotationEditor: { template: "editor_tpl_OCSC" } },
			{ type: 'main', access: 'DEFAULT', tabOrder: [0, 1, 2, 3, 4], hide: { allTasks: true, referrals: false } },
			{ type: 'main', access: 'OCSC', tabOrder: [2, 1, 0, 3, 4], hide: { allTasks: true, referrals: true } },
			{ type: 'batches', access: 'DEFAULT', columnHide: {}, filterable: [{ field: "name", label: "Batch" }, { field: "state", label: "Status" }, { field: "priority", label: "Priority" }, { field: "workflowType", label: "Workflow" }, { field: "parametersLike", label: "Worflow Parameters", isMetadata: true }] },
			{ type: 'batches', access: 'OCSC', columnHide: { priority: true, dueDate: true }, propertiesDecorator: [{ field: "batchName", pattern: ".*?(-KV[0-9]+)", clazz: "hide" }], filterable: [{ field: "name", label: "Batch" }, { field: "state", label: "Case Status" }, { field: "publisher", label: "Case Number", isMetadata: true }, { field: "alternative", label: "Name", isMetadata: true }] },
			{ type: 'tasks', access: 'DEFAULT', myTasks: { columnHide: {}, filterable: [{ field: "productTitle", label: "Document" }, { field: "taskName", label: "Task" }, { field: "batchName", label: "Batch" }, { field: "workflowType", label: "Workflow" }, { field: "dbid", label: "Doc Id", isMetadata: true }], actionHide: { complete: false, reject: false, logs: false } }, unassignedTasks: { columnHide: { batch: false, workflow: false }, filterable: [{ field: "productTitle", label: "Document" }, { field: "taskName", label: "Task" }, { field: "batchName", label: "Batch" }, { field: "workflowType", label: "Workflow" }, { field: "dbid", label: "Doc Id", isMetadata: true }], actionHide: { claim: false, claimAll: true, complete: false, reject: false, logs: false } } },
			{ type: 'tasks', access: 'OCSC', myTasks: { columnHide: { batch: true, workflow: true, priority: true, dueDate: true, state: false }, filterable: [{ field: "productTitle", label: "Document" }, { field: "taskName", label: "Task" }, { field: "publisher", label: "Case Number", isMetadata: true }, { field: "alternative", label: "Name", isMetadata: true }, { field: "resourcename", label: "OC Pay Number", isMetadata: true }], actionHide: { complete: true, reject: true, logs: false } }, unassignedTasks: { columnHide: { batch: true, workflow: true, priority: true, dueDate: true, state: false }, filterable: [{ field: "productTitle", label: "Document" }, { field: "taskName", label: "Task" }, { field: "publisher", label: "Case Number", isMetadata: true }, { field: "alternative", label: "Name", isMetadata: true }, { field: "resourcename", label: "OC Pay Number", isMetadata: true }], actionHide: { claim: true, claimAll: false, complete: true, reject: true, logs: false } } },
			{ type: 'metadata', access: 'DEFAULT', display: [{ field: "dbid", label: "Doc Id", isClaimLink: false, isBatchView: false }] },
			{ type: 'metadata', access: 'OCSC', display: [{ field: "publisher", label: "Case Number", isClaimLink: true, isBatchView: true }, { field: "alternative", label: "Name", isBatchView: true }, { field: "resourcename", label: "OC Pay Number", isBatchView: false }] }
		];

		let i = inclusions.filter((x) => x.access == this.userService.user.domain && x.type == type);

		if (i.length == 0) {
			i = inclusions.filter((x) => x.access == 'DEFAULT' && x.type == type);
		}

		if (i.length != 0) {
			return i[0];
		}

		return undefined;
	}
}
